var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e3a72b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["placeholder", "id"];
const _hoisted_2 = {
    key: 0,
    class: "listContactsContainer"
};
const _hoisted_3 = ["onClick", "id"];
const _hoisted_4 = { class: "flex flex-row gap-3 py-[5px] items-center cursor-pointer" };
const _hoisted_5 = { class: "text-[12px]" };
const _hoisted_6 = { class: "text-[14px] font-medium" };
const _hoisted_7 = { class: "text-[12px] font-normal" };
const _hoisted_8 = {
    key: 1,
    class: "noContactsContainer"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200" }, null, -1));
const _hoisted_10 = ["id"];
const _hoisted_11 = { class: "text-[14px] font-medium" };
import Contact from '@/models/contact';
import { ContactService } from '@/service/ContactService';
import AppState from '@/states/book_appointment';
import { ChevronDownIcon, SearchSmIcon, UserPlus02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UISpin } from '@gohighlevel/ghl-ui';
import { computed, onMounted, ref } from 'vue';
import AddContact from '../BookAppointment/AddContact.vue';
import { appointmentWizardState } from '../BookAppointment/appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchContacts',
    props: {
        isAddContact: Boolean,
        screen: String,
    },
    setup(__props) {
        const props = __props;
        const showDropdown = ref(false);
        const wrapperRef = ref(null);
        const searchQuery = ref('');
        const isContactsLoading = ref(false);
        onMounted(() => {
            const handleClickOutside = event => {
                // Check if 'wrapperRef' is defined and if the clicked target is outside the component
                if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
                    // If the click is outside, hide the options
                    const prevSearchValue = searchQuery.value;
                    searchQuery.value = '';
                    if (prevSearchValue)
                        searchContactByName();
                    showDropdown.value = false;
                }
            };
            // Add an event listener to the document to listen for 'mousedown' events
            document.addEventListener('mousedown', handleClickOutside);
            // Return a cleanup function that removes the event listener when the component is unmounted
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        });
        const onClickContact = (id) => {
            searchQuery.value = '';
            appointmentWizardState.contactError = '';
            if (props.isAddContact) {
                const contactDetails = AppState.contacts.find(info => info.id === id);
                if (contactDetails) {
                    AppState.selectedContact = contactDetails;
                }
            }
            else
                addGuests(id);
            searchQuery.value = '';
            searchContactByName();
            showDropdown.value = false;
        };
        // Function to add guests based on their ID
        const addGuests = (_id) => {
            var _a;
            // Check if the guest with _id is already in the guestsRef array
            const duplicateEntry = appointmentWizardState.guestsRef.find(guest => guest.id === _id);
            // Find the details of the guest using the _id
            const guestDetails = AppState.contacts.find(info => info.id === _id);
            if (!duplicateEntry && // Guest is not a duplicate
                guestDetails.id !== ((_a = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _a === void 0 ? void 0 : _a.id) // Guest is not the same as the selected contact
            ) {
                appointmentWizardState.guestsRef.push(guestDetails); // Add the guest to the guestsRef array
            }
        };
        const filteredContacts = computed(() => {
            let formattedData = [];
            if (props.isAddContact) {
                const guestIds = appointmentWizardState.guestsRef.map(guest => guest.id); // Extract guest IDs
                formattedData = AppState.contacts.filter(contact => !guestIds.includes(contact.id));
            }
            else {
                formattedData = AppState.contacts.filter(contact => { var _a; return contact.id !== ((_a = AppState.selectedContact) === null || _a === void 0 ? void 0 : _a.id); });
            }
            return formattedData;
        });
        const searchContactByName = () => __awaiter(this, void 0, void 0, function* () {
            showDropdown.value = true;
            const val = searchQuery.value;
            isContactsLoading.value = true;
            // Fetch contacts from the API if no matches are found in existing contacts
            const { data } = yield ContactService.searchByName(AppState.locationId, val);
            const contacts = data.contacts.map((contact) => {
                return new Contact(contact);
            });
            let contactsWithName = contacts.filter((contact) => { var _a; return (_a = contact.name) === null || _a === void 0 ? void 0 : _a.trim(); });
            const contactsWithoutName = contacts.filter((contact) => { var _a; return !((_a = contact.name) === null || _a === void 0 ? void 0 : _a.trim()); });
            contactsWithName = contactsWithName.sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            const filteredData = [...contactsWithName, ...contactsWithoutName];
            AppState.contacts = filteredData;
            isContactsLoading.value = false;
        });
        const isSearchDisabled = computed(() => {
            if (!props.isAddContact) {
                return appointmentWizardState.guestsRef.length > 9;
            }
            return false;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "searchMainContainer",
                ref_key: "wrapperRef",
                ref: wrapperRef
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["searchInputContainer", {
                            'cursor-not-allowed opacity-50 pointer-events-none': isSearchDisabled.value,
                        }])
                }, [
                    _createVNode(_unref(SearchSmIcon), { class: "w-5 h-5 text-gray-600" }),
                    _withDirectives(_createElementVNode("input", {
                        class: "border-none outline-none focus:ring-0 focus:border-white hover:border-white",
                        type: "text",
                        placeholder: __props.isAddContact
                            ? _ctx.$t('addContact.search_by_name_email_phone_or_company')
                            : _ctx.$t('addContact.search_placeholder'),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                        id: __props.screen + '-search-contacts',
                        name: "searchQuery",
                        onInput: searchContactByName
                    }, null, 40, _hoisted_1), [
                        [_vModelText, searchQuery.value]
                    ]),
                    (isContactsLoading.value)
                        ? (_openBlock(), _createBlock(_unref(UISpin), {
                            key: 0,
                            size: 20
                        }))
                        : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                            key: 1,
                            class: "w-5 h-5 text-gray-600",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showDropdown.value = !showDropdown.value))
                        }))
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(showDropdown.value ? 'dropDownList' : 'hiddenDropDownList'),
                    style: _normalizeStyle({ width: __props.isAddContact ? '35%' : '93%' })
                }, [
                    (filteredContacts.value.length > 0 && showDropdown.value)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContacts.value, (contact, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    onClick: ($event) => (onClickContact(contact.id)),
                                    id: 'contact-' + index
                                }, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_unref(UIAvatar), {
                                            size: 32,
                                            style: _normalizeStyle({
                                                color: '#fff',
                                                backgroundColor: contact.profileColor,
                                            })
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(contact.initials), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["style"]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_6, _toDisplayString(contact.name), 1),
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(contact.email || '-'), 1)
                                        ])
                                    ])
                                ], 8, _hoisted_3));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('addContact.no_contact_found')), 1)
                        ])),
                    _createElementVNode("div", null, [
                        _hoisted_9,
                        _createElementVNode("div", {
                            class: "addContactContainer",
                            id: __props.isAddContact ? 'add-new-contact' : 'add-new-guest',
                            onClick: _cache[2] || (_cache[2] = ($event) => (_unref(appointmentWizardState).showAddContactModal =
                                !_unref(appointmentWizardState).showAddContactModal))
                        }, [
                            _createVNode(_unref(UserPlus02Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.isAddContact
                                ? _ctx.$t('addContact.add_new_contact')
                                : _ctx.$t('addContact.add_new_guest')), 1)
                        ], 8, _hoisted_10)
                    ])
                ], 6),
                (_unref(appointmentWizardState).showAddContactModal)
                    ? (_openBlock(), _createBlock(AddContact, {
                        key: 0,
                        "add-contact": __props.isAddContact
                    }, null, 8, ["add-contact"]))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
